"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _commons = require("@focaltec-suite/commons");
var _CurrencyExchangeRateExpandable = _interopRequireDefault(require("./CurrencyExchangeRateExpandable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function CurrencyExchangeRateTree(_ref) {
  var exchangeRate = _ref.exchangeRate,
    currencies = _ref.currencies;
  var _a;
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body1",
    fontWeight: "bold",
    gutterBottom: true
  }, (0, _core.translate)('currencies.exchange_rate.tree'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      pt: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_commons.Griddable, {
    items: (_a = exchangeRate === null || exchangeRate === void 0 ? void 0 : exchangeRate.items) !== null && _a !== void 0 ? _a : [],
    getId: function getId(item) {
      return item.currency_id;
    },
    empty: (0, _core.translate)('currencies.exchange_rate.empty_tree'),
    loading: false,
    hoverable: false,
    expandable: {
      mapper: function mapper(item) {
        return /*#__PURE__*/_react["default"].createElement(_CurrencyExchangeRateExpandable["default"], {
          item: item,
          currencies: currencies
        });
      },
      expanded: true
    },
    columns: [{
      title: (0, _core.translate)('currencies.single'),
      converter: function converter(item, index, indexRow) {
        var currency = currencies.find(function (el) {
          return el.id === item.currency_id;
        });
        if (currency) {
          return "".concat(currency.name, " (").concat(currency.id, ")");
        }
        return item.currency_id;
      },
      width: 'currency',
      xs: true
    }, {
      title: (0, _core.translate)('currencies.exchange_rate.value'),
      converter: function converter(item, index, indexRow) {
        return (0, _commons.formatCurrecy)({
          value: item.value,
          currencyId: exchangeRate.currency_id,
          maxDecimals: 7
        });
      },
      width: 'value',
      xs: 'auto'
    }]
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(CurrencyExchangeRateTree);